import { ready } from "../../api/apiUtils";
import { formatDateHHmm } from "../../utils/date";
import { features } from "../../features";
export var DrupalDaysOfWeek = /*#__PURE__*/ function(DrupalDaysOfWeek) {
    DrupalDaysOfWeek[DrupalDaysOfWeek["Zondag"] = 0] = "Zondag";
    DrupalDaysOfWeek[DrupalDaysOfWeek["Maandag"] = 1] = "Maandag";
    DrupalDaysOfWeek[DrupalDaysOfWeek["Dinsdag"] = 2] = "Dinsdag";
    DrupalDaysOfWeek[DrupalDaysOfWeek["Woensdag"] = 3] = "Woensdag";
    DrupalDaysOfWeek[DrupalDaysOfWeek["Donderdag"] = 4] = "Donderdag";
    DrupalDaysOfWeek[DrupalDaysOfWeek["Vrijdag"] = 5] = "Vrijdag";
    DrupalDaysOfWeek[DrupalDaysOfWeek["Zaterdag"] = 6] = "Zaterdag";
    return DrupalDaysOfWeek;
}({});
export const parseDrupalOpeningHours = (drupalOpeningHours)=>{
    const hours = drupalOpeningHours.map((item)=>parseDrupalOpeningHourItem(item));
    return hours.toArray();
};
export const parseOpeningHours = (googleOpeningHours, drupalOpeningHours, googlePlacesId)=>{
    switch(features().openingHours){
        case "drupal":
            return parseDrupalOpeningHours(drupalOpeningHours);
        case "google":
            var _googleOpeningHours_CurrentOpeningHours;
            if (!googlePlacesId) return parseDrupalOpeningHours(drupalOpeningHours);
            if (!ready(googleOpeningHours)) return [];
            const periods = (googleOpeningHours === null || googleOpeningHours === void 0 ? void 0 : (_googleOpeningHours_CurrentOpeningHours = googleOpeningHours.CurrentOpeningHours) === null || _googleOpeningHours_CurrentOpeningHours === void 0 ? void 0 : _googleOpeningHours_CurrentOpeningHours.Periods) ?? [];
            let openingTimes = periods.filter((item)=>item.Open).map((item)=>parseGoogleOpeningHourItem(item));
            openingTimes = openingTimes.map((item)=>{
                const drupalItem = drupalOpeningHours.find((d)=>DrupalDaysOfWeek[d.field_day] === item.day);
                if (drupalItem) {
                    item.additionalInformation = drupalItem.field_additional_information || '';
                }
                return item;
            });
            return openingTimes;
    }
};
export const parseDrupalOpeningHourItem = (item)=>{
    return {
        day: DrupalDaysOfWeek[item.field_day],
        open: !item.field_closed,
        readableTime: item.field_closed ? 'Gesloten' : `${item.field_opening_time} - ${item.field_closing_time}`,
        additionalInformation: item.field_additional_information || ''
    };
};
export const parseGoogleOpeningHourItem = (item)=>{
    if (!item.Open) return fallBackOpeningHour;
    return {
        day: item.Open.Day,
        open: true,
        readableTime: item.Close ? `${formatDateHHmm(item.Open.Date)} - ${formatDateHHmm(item.Close.Date)}` : '24 uur geopend',
        additionalInformation: ''
    };
};
export const combineOpeningHours = (googleHours)=>{
    if (googleHours.length === 0) return null;
    return {
        day: googleHours[0].day,
        open: googleHours[0].open,
        readableTime: googleHours.map((g)=>g.readableTime).join(', '),
        additionalInformation: googleHours[0].additionalInformation
    };
};
export const fallBackOpeningHour = {
    day: 0,
    open: false,
    readableTime: 'Gesloten',
    additionalInformation: ''
};
